import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyContract({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <filter
          x="-7%"
          y="-4.2%"
          width="114%"
          height="111.7%"
          filterUnits="objectBoundingBox"
          id="pic-empty-contract_svg__a"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <rect id="pic-empty-contract_svg__b" width={100} height={120} rx={4} />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h240v168H0z" />
        <path
          d="M178.5 155c-40.2-9.93-77 7.5-102 7.5-40.5 0-79.08-37.6-70.5-79C14.03 44.77 72.45 47.8 108 28c109.5-61 112.5 22 126 64s-13 73.5-55.5 63z"
          fill="#E9EDFB"
        />
        <path
          d="M232.85 134.72l-.31.62C223.74 152.48 204 161.3 178.5 155c-40.2-9.93-77 7.5-102 7.5-30.12 0-59.18-20.8-68.56-48.49 24.95 11.65 58.25 13.5 111.56-3.51 62.31-19.89 93.76 2.8 113.35 24.22z"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <g transform="translate(72 27)">
          <use
            fill="#000"
            filter="url(#pic-empty-contract_svg__a)"
            xlinkHref="#pic-empty-contract_svg__b"
          />
          <use fill="#FFF" xlinkHref="#pic-empty-contract_svg__b" />
        </g>
        <path
          d="M111 97a1 1 0 011 1v4a1 1 0 01-1 1H83a1 1 0 01-1-1v-4a1 1 0 011-1h28zm30-12a1 1 0 011 1v4a1 1 0 01-1 1H83a1 1 0 01-1-1v-4a1 1 0 011-1h58zm20-12a1 1 0 011 1v4a1 1 0 01-1 1H83a1 1 0 01-1-1v-4a1 1 0 011-1h78zm0-12a1 1 0 011 1v4a1 1 0 01-1 1H83a1 1 0 01-1-1v-4a1 1 0 011-1h78zm-57-18a2 2 0 012 2v8a2 2 0 01-2 2H84a2 2 0 01-2-2v-8c0-1.1.9-2 2-2h20z"
          fill="#E3E8E8"
        />
        <g transform="rotate(35 9.3 326.14)">
          <path
            d="M5.87 0h6.26a1 1 0 011 .86l.87 6.2v33.86l-1.22 39.11a1 1 0 01-1 .97H6.22a1 1 0 01-1-.97L4 41.03V7.21L4.88.86a1 1 0 011-.86z"
            fill="#56A"
          />
          <path fill="#8F9DD6" d="M4 38h10v2H4zM1 7h13v2H0V8a1 1 0 011-1zM0 9h2v26H0z" />
          <circle fill="#8F9DD6" cx={2} cy={33} r={2} />
          <path
            d="M12.2 82l2.8 7.08-6 9.72-6-9.72L5.8 82h6.4zM9 88a1.2 1.2 0 100 2.4A1.2 1.2 0 009 88z"
            fill="#8F9DD6"
          />
        </g>
        <g transform="translate(83 107)">
          <path fill="#8F9DD6" d="M6.5 17.33h13v19.5l-6.5-6.5-6.5 6.5z" />
          <path
            fill="#FB8F23"
            d="M13 23.54l-4.45 1.68-2.33-4.14-4.48-1.58.88-4.67L.2 10.74l3.67-3.01.77-4.69 4.75.05L13 0l3.6 3.1 4.76-.06.77 4.69 3.67 3.01-2.42 4.1.88 4.66-4.48 1.58-2.33 4.14z"
          />
          <circle fill="#FFE266" cx={13} cy={13} r={6.5} />
        </g>
      </g>
    </svg>
  );
}

SvgPicEmptyContract.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyContract.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyContract svgRef={ref} {...props} />
));
export default ForwardRef;
